import { getSanityNextImage } from "@lib/getImages";

export function resolveMediaSources(src) {
  if (!src || !src.asset) {
    return null;
  }
  const sizes = {
    large: {
      width: 1200,
      height: 1800,
    },
    medium: { width: 1200, height: 1800 },
    small: { width: 1200, height: 1800 },
  };

  return getSanityNextImage(src, sizes, src.altText);
}
